const generateMedia = (minWidth, maxWidth) => {
  const minWidthValue = minWidth ? `(min-width:${minWidth}px)` : '';
  const maxWidthValue = maxWidth ? `(max-width:${maxWidth}px)` : '';
  if (minWidthValue && maxWidthValue) {
    return `${minWidthValue} and ${maxWidthValue}`;
  }
  return minWidthValue || maxWidthValue;
};

export { generateMedia as g };
